import {makeAutoObservable} from 'mobx';
import {AIRepository} from '../../../data/repositories/AiRepository';
import {MyAssitantListItem} from '../../../data/models/AI/AiAssistantModels';

class LearnerAiAssistantsStore {
  private aiRepository = new AIRepository();

  constructor() {
    makeAutoObservable(this);
  }

  public async getMyAiAssistants(courseId?: string) {
    const result = await this.aiRepository.getMyAiAssitants(courseId);
    if (result.success && result.data) {
      return this.sortAiAssistants(result.data);
    }
    return [];
  }

  private sortAiAssistants(assistants: MyAssitantListItem[]) {
    return assistants.sort((a, b) => a.name.localeCompare(b.name));
  }
}

export default LearnerAiAssistantsStore;
